var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderRef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 289,
    viewBox: "0 0 1920 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4325_14509)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 289,
    fill: "url(#paint0_radial_4325_14509)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 289C9.49839 270.426 27.9899 225.985 73.9687 196.807C131.442 160.335 203.909 233.279 266.38 233.279C323.354 233.279 383.326 187.182 449.296 162.868C515.265 138.553 571.739 119.811 637.209 127.916C665.135 131.373 728.167 155.27 760.152 176.038C792.138 196.807 802.133 230.24 799.634 245.436C792.799 287.002 760.152 282.415 760.152 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 289C17.3838 273.389 35.2698 236.036 79.743 211.513C135.334 180.858 205.428 242.167 265.854 242.167C320.962 242.167 378.97 203.423 442.78 182.987C506.589 162.551 561.214 146.798 624.54 153.61C651.552 156.516 712.519 176.601 743.457 194.057C774.395 211.513 784.063 239.613 781.646 252.385C775.035 287.32 743.457 283.465 743.457 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 289C27.2384 276.01 44.3559 244.928 86.9181 224.522C140.121 199.014 207.203 250.029 265.032 250.029C317.772 250.029 373.288 217.79 434.356 200.785C495.423 183.78 547.701 170.672 608.306 176.34C634.157 178.758 692.505 195.471 722.113 209.996C751.722 224.522 760.974 247.904 758.661 258.532C752.334 287.602 722.113 284.395 722.113 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 289C37.1018 278.517 53.4973 253.433 94.2644 236.965C145.223 216.379 209.476 257.55 264.866 257.55C315.382 257.55 368.556 231.532 427.048 217.809C485.54 204.085 535.613 193.507 593.661 198.081C618.422 200.032 674.309 213.52 702.669 225.243C731.029 236.965 739.891 255.835 737.676 264.412C731.616 287.872 702.669 285.283 702.669 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 289C47.9697 281.479 63.6665 263.485 102.696 251.67C151.484 236.903 212.998 266.438 266.028 266.438C314.391 266.438 365.299 247.773 421.299 237.928C477.298 228.083 525.237 220.494 580.812 223.776C604.518 225.175 658.023 234.852 685.175 243.261C712.326 251.67 720.811 265.208 718.689 271.361C712.888 288.191 685.175 286.334 685.175 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 289C59.7978 284.328 74.5864 273.15 111.358 265.81C157.322 256.636 215.277 274.984 265.238 274.984C310.803 274.984 358.766 263.389 411.525 257.274C464.284 251.158 509.449 246.443 561.808 248.482C584.142 249.351 634.552 255.362 660.132 260.586C685.712 265.81 693.706 274.22 691.707 278.042C686.241 288.497 660.132 287.344 660.132 289",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 289C73.6216 286.607 87.4785 280.881 121.934 277.122C165.003 272.424 219.307 281.821 266.121 281.821C308.815 281.821 353.757 275.882 403.193 272.75C452.628 269.617 494.948 267.203 544.009 268.247C564.937 268.692 612.171 271.771 636.139 274.447C660.108 277.122 667.598 281.43 665.726 283.388C660.604 288.743 636.139 288.152 636.139 289",
    stroke: "white",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2327 -50C2323.5 -31.4263 2305.01 13.0154 2259.03 42.1929C2201.56 78.6649 2129.09 5.72098 2066.62 5.72098C2009.65 5.72097 1949.67 51.8175 1883.7 76.1321C1817.73 100.447 1761.26 119.189 1695.79 111.084C1667.86 107.627 1604.83 83.7302 1572.85 62.9615C1540.86 42.1929 1530.87 8.76 1533.37 -6.43646C1540.2 -48.0016 1572.85 -43.4152 1572.85 -50.0001",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2319 -50C2315.62 -34.389 2297.73 2.96386 2253.26 27.4873C2197.67 58.1416 2127.57 -3.16702 2067.15 -3.16703C2012.04 -3.16703 1954.03 35.5767 1890.22 56.0129C1826.41 76.4491 1771.79 92.2017 1708.46 85.3899C1681.45 82.4843 1620.48 62.399 1589.54 44.9431C1558.6 27.4872 1548.94 -0.612768 1551.35 -13.3852C1557.96 -48.3204 1589.54 -44.4655 1589.54 -50.0001",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2309 -50C2305.76 -37.0098 2288.64 -5.92789 2246.08 14.4785C2192.88 39.9865 2125.8 -11.0295 2067.97 -11.0295C2015.23 -11.0295 1959.71 21.2098 1898.64 38.2151C1837.58 55.2204 1785.3 68.3284 1724.69 62.6602C1698.84 60.2424 1640.5 43.5291 1610.89 29.0038C1581.28 14.4784 1572.03 -8.90406 1574.34 -19.5323C1580.67 -48.6024 1610.89 -45.3947 1610.89 -50.0001",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2299 -50C2295.9 -39.5167 2279.5 -14.433 2238.74 2.03527C2187.78 22.6207 2123.52 -18.5501 2068.13 -18.5501C2017.62 -18.5501 1964.44 7.46753 1905.95 21.1911C1847.46 34.9147 1797.39 45.4931 1739.34 40.9188C1714.58 38.9675 1658.69 25.4796 1630.33 13.7574C1601.97 2.03522 1593.11 -16.8349 1595.32 -25.412C1601.38 -48.8721 1630.33 -46.2834 1630.33 -50.0001",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288 -50C2285.03 -42.4794 2269.33 -24.4846 2230.3 -12.6703C2181.52 2.09742 2120 -27.4381 2066.97 -27.4381C2018.61 -27.4381 1967.7 -8.7733 1911.7 1.07187C1855.7 10.9171 1807.76 18.5059 1752.19 15.2243C1728.48 13.8245 1674.98 4.14839 1647.83 -4.261C1620.67 -12.6704 1612.19 -26.2076 1614.31 -32.3608C1620.11 -49.1909 1647.83 -47.3338 1647.83 -50.0001",
    stroke: "white",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4325_14509",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1920 -3.44515e-05) rotate(163.246) scale(1002.56 886.623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4325_14509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 289,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRef);
export default __webpack_public_path__ + "static/media/header_ref.3404ddfb150c35ea966ac9f252760678.svg";
export { ForwardRef as ReactComponent };